import { GReview, Text, VStack } from '@gazin/ecommerce-ui'
import React from 'react'

interface AverageRatingProps {
  rating: number
}

export const AverageRating: React.FC<AverageRatingProps> = ({ rating }) => {
  return (
    <VStack
      backgroundColor="neutral.50"
      borderRadius="0.5rem"
      minHeight={{ base: '6.5rem', md: '11rem' }}
      padding={{ base: '1.5rem', md: '3rem' }}
      width="100%"
    >
      <Text
        color="neutral.700"
        fontSize={{ base: '0.875rem', md: '1.25rem' }}
        fontWeight={{ base: '400', md: '700' }}
      >
        Nota média
      </Text>
      <GReview
        description={rating.toFixed(1)}
        fontSize={{ base: '1.75rem', md: '1.75rem' }}
        fontWeight="600"
        rating={rating}
        starSize={{ base: '2.25rem', md: '2rem' }}
      />
    </VStack>
  )
}
